
import SimpleEvent from './../../zviz2/zviz/event';


class Video{

    constructor(settings={}){

        this.events = [];
        this.closeEvents = {};
        this.language = settings.language || 'english';

        let videos = document.getElementsByClassName('video');
        for(let i = 0; i < videos.length; i++){
            for(let c = 0; c < videos[i].childNodes.length; c++){
                let v = videos[i].childNodes[c];
                if(v.tagName && v.tagName.toLowerCase() == 'a'){
                    this.events.push(new SimpleEvent(v, 'click', [this, this.openVideo]));
                }
            }
        }

    }

    openVideo(event){
        event.preventDefault();
        let v = event.currentTarget;
        let url = v.getAttribute('href');
        let p = v.parentNode;
        while(p.parentNode && p.className != 'project' && p.className != 'indicatorVisual'){
            p = p.parentNode;
        }
        let width = p.clientWidth;
        let height = Math.min(0.6 * width, 550);
        p.style.minHeight = height + 'px';
        if(p.className == 'indicatorVisual'){
            p.style.paddingTop = '30px';
        }

        // youtube
        let embed = '<iframe width="' + width + '" height="'+height+'" src="' + url + '" frameborder="0" allowfullscreen></iframe>';
        if(v.parentNode.className.indexOf('vimeo') > -1){
            // vimeo
            embed = '<iframe src="' + url + '" width="' + width + '" height="'+height+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
        }
        embed = '<div class="innerVideo">' + embed + '</div>';

        let div = document.createElement('div');
        div.className = 'videoPlayer';
        div.style.opacity = 0;
        div.innerHTML = embed;

        let id = Math.round(999999*Math.random());
        let a = document.createElement('a');
        a.id = id;
        a.className = 'closeVideo';
        a.setAttribute('href', '#');
        a.textContent = this.language =='english'? 'Close video': 'Video sluiten';

        p.appendChild(div);

        p.appendChild(a);
        this.closeEvents[id] = new SimpleEvent(a, 'click', [this, this.onClose]);

        let page = window.themeId? 'theme-'+window.themeId: 'video';
        if(window.countryId){
            page = 'country-' + window.countryId; 
        }
        zolabo.trackEvent('video', page, url);

        // div.style.opacity = 1;
        setTimeout(function(){  div.style.opacity = 1; }, 100);
    }

    onClose(event){
        event.preventDefault();
        let elm = event.currentTarget;
        this.closeVideo(elm);
    }

    closeVideo(elm){
        let id = elm.id;
        if(this.closeEvents[id]){
            this.closeEvents[id].remove();
            delete this.closeEvents[id];
        }else{
            console.warn('could not find event');
        }

        let p = elm.parentNode;
        p.removeChild(elm);
        let player = p.getElementsByClassName('videoPlayer');
        if(p.className == 'indicatorVisual'){
            p.style.paddingTop = '0px';
        }
        if(player[0]){
            player[0].style.opacity = 0;
        }
        setTimeout(function(){
            if(player[0]){
                p.removeChild(player[0]);
            }
            p.style.minHeight = 'auto';
        }, 300);

    }


    remove(){
        for(let i = 0; i < this.events.length; i++){
            this.events[i].remove();
        }
        this.events = [];
    }

}

export default Video;